<template>
  <article class="contact-page page type-page status-publish hentry">

    <header class="entry-header"  v-lazy:background-image="'https://api.alt-design.net/api/image/' + page.header_image[randomImage]" >
      <p class="sectors">{{ page.sub_title }}</p>
      <h1 class="entry-title">{{ page.title || 'About' }}</h1>
    </header><!-- .entry-header -->
    <div class="entry-content">
      <!--<h2>So we can get back to you quickly, choose an option below&hellip;</h2>-->

      <div class="row ">
        <div class="block hello animateIn">
          <h3>I'd just like to say hello&hellip;</h3>
          <a title="Say hello" class="button hello" id="showHelloForm" @click="toggleVisibility('.hello-form')">Say hello</a>
        </div>
        <div class="block talk animateIn">
          <h3>Talk about your project&hellip;</h3>
          <a title="Say hello" class="button talk" id="showTalkForm" @click="toggleVisibility('.talk-form')">We need some details</a>
        </div>
        <div class="block hello-form animateIn">
          <form v-show="!helloSent" @submit.prevent="sendHello">
              <p class="label">Hello, nice to meet ya&hellip;</p>

              <div class="form-wrapper">
                <div class="left">
                  <div class="field">
                    <label for="name">Name</label>
                    <input type="text" required value="" v-model="helloForm.name" name="name" id="name" placeholder="Name" />
                  </div>
                  <div class="field">
                    <label for="email">Email</label>
                    <input type="email" required value="" v-model="helloForm.email" name="email" id="email" placeholder="Email" />
                  </div>
                  <div class="field">
                    <label for="telephone">Tel</label>
                    <input type="text" required value="" v-model="helloForm.telephone" name="telephone" id="telephone" placeholder="Tel" />
                  </div>
                  <div class="field">
                    <label for="company">Company</label>
                    <input type="text" required value="" v-model="helloForm.company" name="company" id="company" placeholder="Company" />
                  </div>
                </div>

                <div class="right">
                  <div class="field">
                    <label for="message">Finally, let's say hello...</label>
                    <textarea name="message" required id="message" v-model="helloForm.message" cols="30" rows="30" placeholder="Finally, let's say hello..."></textarea>
                  </div>
                </div>
              </div>

              <div class="submit">
                  <ul class="gdpr checkboxes">
                    <li><input class="blue" type="checkbox" v-model="helloForm.consent" name="consent" id="consent_hello" value="Yes" /><label for="consent_hello"><span class="blue"></span>I’m more than happy to be kept up-to-date by email on news and other activities.</label></li>
                  </ul>
                <button class="hello" type="submit">Submit</button>
              </div>
          </form>
          <p v-show="helloSent" class="message-confirm">Thanks for getting in touch.</p>
        </div>
        <div class="block talk-form animateIn">
         <form v-show="!talkSent" @submit.prevent="sendTalk">
              <ul class="checkboxes">
                <li class="label">What's the project then?</li>
                <li><input type="checkbox" v-model="talkForm.services" name="checkbox_website" id="checkbox_website" value="Website" /><label for="checkbox_website"><span></span>Website</label></li>
                <li><input type="checkbox" v-model="talkForm.services" name="checkbox_cms" id="checkbox_cms" value="Content Management System" /><label for="checkbox_cms"><span></span>Content Management System</label></li>
                <li><input type="checkbox" v-model="talkForm.services" name="checkbox_email" id="checkbox_email" value="Email Marketing" /><label for="checkbox_email"><span></span>Email Marketing</label></li>
                <li><input type="checkbox" v-model="talkForm.services" name="checkbox_social" id="checkbox_social" value="Social Media Marketing" /><label for="checkbox_social"><span></span>Social Media Marketing</label></li>
                <li><input type="checkbox" v-model="talkForm.services" name="checkbox_ecommerce" id="checkbox_ecommerce" value="E-Commerce" /><label for="checkbox_ecommerce"><span></span>E-Commerce</label></li>
                <li><input type="checkbox" v-model="talkForm.services" name="checkbox_branding" id="checkbox_branding" value="Branding" /><label for="checkbox_branding"><span></span>Branding</label></li>
                <li><input type="checkbox" v-model="talkForm.services" name="checkbox_print" id="checkbox_print" value="Print" /><label for="checkbox_print"><span></span>Print</label></li>
                <li><input type="checkbox" v-model="talkForm.services" name="checkbox_photography" id="checkbox_photography" value="Motion/Photography" /><label for="checkbox_photography"><span></span>Motion/Photography</label></li>
              </ul>

              <p class="label">We need just a smidge more info&hellip;</p>

              <div class="form-wrapper">
                <div class="left">
                  <div class="field">
                    <label for="name">Name</label>
                    <input required type="text" v-model="talkForm.name" name="name" id="name" placeholder="Name" />
                  </div>
                  <div class="field">
                    <label for="email">Email</label>
                    <input required type="email" v-model="talkForm.email" value="" name="email" id="email" placeholder="Email" />
                  </div>
                  <div class="field">
                    <label for="telephone">Tel</label>
                    <input required type="text" v-model="talkForm.telephone" value="" name="telephone" id="telephone" placeholder="Tel" />
                  </div>
                  <div class="field">
                    <label for="company">Company</label>
                    <input required type="text" v-model="talkForm.company" value="" name="company" id="company" placeholder="Company" />
                  </div>
                </div>

                <div class="right">
                  <div class="field">
                    <label for="budget">Select a budget for your project&hellip;</label>
                    <multiselect v-model="talkForm.budget" :options="['Under £1,500','£1,500 - £3,000','£3,000 - £7,000','£7,000 - £12,000','Over £12,000']" :show-labels="false" placeholder="Select a budget for your project..."></multiselect>
                  </div>
                  <div class="field">
                    <label for="deadline">And, when is the deadline?</label>
                    <multiselect v-model="talkForm.deadline" :options="['0-2 Weeks', '2-4 Weeks', '4-6 Weeks', '6-8 Weeks', '8-12 Weeks', 'Not important, I want it right']" :show-labels="false" placeholder="And, when is the deadline?"></multiselect>
                  </div>
                  <div class="field">
                    <label for="message">Finally, a sentence or two about the project...</label>
                    <textarea name="message" v-model="talkForm.message" id="message" cols="30" rows="10" placeholder="Finally, a sentence or two about the project..."></textarea>
                  </div>
                </div>
              </div>

              <div class="submit">
                <ul class="gdpr checkboxes">
                  <li><input type="checkbox" v-model="talkForm.consent" name="consent" id="consent_talk" value="Yes" /><label for="consent_talk"><span></span>I’m more than happy to be kept up-to-date by email on news and other activities.</label></li>
                </ul>
                <button class="talk" type="submit">Submit</button>
              </div>
          </form>
          <p v-show="talkSent" class="message-confirm">Thanks for getting in touch.</p>
        </div>
      </div>

      <div class="row">
        <div class="block contact animateIn">
          <p>Call<br />
          <span class="link">01332 208733</span></p>

          <p>Email<br />
          <a href="mailto:info@alt-design.net">info@alt-design.net</a></p>

          <p>Alt Design Ltd<br />
          Thorncliffe House<br />
          278 Uttoxeter New Rd<br />
          Derby<br />
          Derbyshire DE22 3LN</p>

          <p>Follow us on…</p>
          <div class="social-buttons">
            <ul>
              <li class="facebook"><a href="https://www.facebook.com/altdesignderby/" target="_blank" title="Find us on Facebook"><span class="icon-facebook"></span></a></li>
              <li class="twitter"><a href="https://twitter.com/_altdesign" target="_blank" title="Follow us on Twitter"><span class="icon-twitter"></span></a></li>
              <li class="instagram"><a href="https://www.instagram.com/_altdesign/" target="_blank" title="Follow us on Instagram"><span class="icon-instagram"></span></a></li>
            </ul>
          </div>
        </div>
        <div class="block map animateIn">
          <div class="map-container">
            <gmap-map v-if="map" :center="center" :zoom="16" :options="{styles: styles}">
              <gmap-marker :position="center"></gmap-marker>
            </gmap-map>
          </div>
        </div>
      </div>

      <p class="legal"><strong>Legal waffle.</strong> Registered Office as above and Registered in England and Wales: 4682630</p>
    </div>

  </article>
</template>

<script>
  import Multiselect from 'vue-multiselect'

  export default {
    components: {
      Multiselect
    },
    methods: {
      sendHello () {
        window.api.post('form?form_id=1', this.helloForm).then(res => {
          this.helloSent = true
        })
      },
      sendTalk () {
        window.api.post('form?form_id=2', this.talkForm).then(res => {
          this.talkSent = true
        })
      },
      updateCenter (center) {
        clearTimeout(this.timeout)
        this.map = false

        this.timeout = setTimeout(() => {
          this.map = true
        }, 250)
      },
      toggleVisibility (el) {
        el = document.querySelector(el)
        let activeObjects = document.querySelectorAll('.active')

        Array.prototype.forEach.call(activeObjects, function (element, index) {
          element.style.maxHeight = '0px'
          element.style.opacity = '0'
          element.classList.remove('active')
        })

        if (el.style.maxHeight === '9999px') {
          el.style.maxHeight = '0px'
          el.style.opacity = '0'
          el.classList.remove('active')
        } else {
          el.style.maxHeight = '9999px'
          el.style.opacity = '1'
          el.classList.toggle('active')
        }
      },
      populateTalkForm () {
        this.talkForm.name = this.$route.query.name
        this.talkForm.services = []
        this.talkForm.services.push(this.$route.query.subject)
      }
    },
    created () {
      window.api.get('get-pages/contact-us').then(res => {
        this.page = res.data.data.page
        this.randomImage = Math.floor(Math.random() * this.page.header_image.length)
      })
      window.api.get('get-pages-by-type/2').then(res => {
        this.projects = res.data.data
      }).then(() => {
        this.$setTweens()
      })
      this.populateTalkForm()
    },
    mounted () {
      window.addEventListener('resize', this.updateCenter)

      setTimeout(() => {
        if (this.$route.query.showtalk === 'true') {
          this.toggleVisibility('.talk-form')
        }
      }, 500)

      if (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream) {
        setTimeout(() => {
          let options = document.querySelectorAll('.multiselect__option')
          for (let option of options) {
            option.addEventListener('click', e => {
              e.target.click()
            })
            option.addEventListener('touchend', e => {
              e.target.click()
            })
          }
        }, 3000)
      }
      // this.$store.commit('setShowApp', true)
    },
    data () {
      return {
        page: '',
        randomImage: 0,
        map: true,
        timeout: null,
        helloSent: false,
        talkSent: false,
        helloForm: {
          name: '',
          email: '',
          telephone: '',
          company: '',
          message: '',
          consent: 0
        },
        talkForm: {
          name: '',
          subject: '',
          talk: '',
          email: '',
          telephone: '',
          company: '',
          budget: '',
          deadline: '',
          services: '',
          message: '',
          consent: 0
        },
        center: {
          lat: 52.918211,
          lng: -1.499792
        },
        styles: [
          {
            'featureType': 'water',
            'elementType': 'geometry',
            'stylers': [
              {
                'color': '#e9e9e9'
              },
              {
                'lightness': 17
              }
            ]
          },
          {
            'featureType': 'landscape',
            'elementType': 'geometry',
            'stylers': [
              {
                'color': '#f5f5f5'
              },
              {
                'lightness': 20
              }
            ]
          },
          {
            'featureType': 'road.highway',
            'elementType': 'geometry.fill',
            'stylers': [
              {
                'color': '#ffffff'
              },
              {
                'lightness': 17
              }
            ]
          },
          {
            'featureType': 'road.highway',
            'elementType': 'geometry.stroke',
            'stylers': [
              {
                'color': '#ffffff'
              },
              {
                'lightness': 29
              },
              {
                'weight': 0.2
              }
            ]
          },
          {
            'featureType': 'road.arterial',
            'elementType': 'geometry',
            'stylers': [
              {
                'color': '#ffffff'
              },
              {
                'lightness': 18
              }
            ]
          },
          {
            'featureType': 'road.local',
            'elementType': 'geometry',
            'stylers': [
              {
                'color': '#ffffff'
              },
              {
                'lightness': 16
              }
            ]
          },
          {
            'featureType': 'poi',
            'elementType': 'geometry',
            'stylers': [
              {
                'color': '#f5f5f5'
              },
              {
                'lightness': 21
              }
            ]
          },
          {
            'featureType': 'poi.park',
            'elementType': 'geometry',
            'stylers': [
              {
                'color': '#dedede'
              },
              {
                'lightness': 21
              }
            ]
          },
          {
            'elementType': 'labels.text.stroke',
            'stylers': [
              {
                'visibility': 'on'
              },
              {
                'color': '#ffffff'
              },
              {
                'lightness': 16
              }
            ]
          },
          {
            'elementType': 'labels.text.fill',
            'stylers': [
              {
                'saturation': 36
              },
              {
                'color': '#333333'
              },
              {
                'lightness': 40
              }
            ]
          },
          {
            'elementType': 'labels.icon',
            'stylers': [
              {
                'visibility': 'off'
              }
            ]
          },
          {
            'featureType': 'transit',
            'elementType': 'geometry',
            'stylers': [
              {
                'color': '#f2f2f2'
              },
              {
                'lightness': 19
              }
            ]
          },
          {
            'featureType': 'administrative',
            'elementType': 'geometry.fill',
            'stylers': [
              {
                'color': '#fefefe'
              },
              {
                'lightness': 20
              }
            ]
          },
          {
            'featureType': 'administrative',
            'elementType': 'geometry.stroke',
            'stylers': [
              {
                'color': '#fefefe'
              },
              {
                'lightness': 17
              },
              {
                'weight': 1.2
              }
            ]
          }
        ]
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/Pages/Contact.vue